/* SupremeFolio's Portfolio file*/

/* Change this file to get your personal Porfolio */

/* Some Tips:
★ Place your images in "src/assets/images" path
★ Place your custom loading animations in assets/lottie
★ Set value to false to hide a section or an entire page
★ Get fontAwesomeClassnames from https://www.fontawesome.com
★ Set blogSection false to hide all kind of blogs
*/

/*
Some informations are kept unchanged according to component owners
Credits: masterPortfolio(https://github.com/ashutosh1919/masterPortfolio)
         developerFolio(https://github.com/saadpasta/developerFolio)
*/

// Website related settings
// Which pages will be enabled

const pageEnabled = {
  splash: true, // Change this to false if you don't want Splash screen

  education: true, // Change this to false if you don't want education (degrees, certifications, competitiveSites) page

  projects: true, // Change this to false if you don't want projects (from github data) and publications page

  opensource: false, // Change this to false if you don't want opensource contribution (from github data) page

  hobbies: false, // Change this to false if you don't want hobbies page

  experience: true, // Change this to false if you don't want experience page

  contact: true, // Change this to false if you don't want contact page
};

// Routing with or without '#'
const routerValue =
  "HashRouter"; /* Supported values:
                     1. HashRouter(for github hosted user Pages)
                     2. BrowserRouter (for regular hosting)
                     */

// Splash Screen

const splashScreen = {
  useLottie: true, // setting it false will show animation of src/components/loader
  animationFile:
    "starLoading" /* Supported Values
                                     1. splashAnimation
                                     2. email
                                     3. build
                                     4. landingPerson
                                     5. codingPerson
                                     6. geometricLoader
                                     7. starLoading
                                     8. ripple
                                     9. nightDay
                                     10. littleRobot
                                     11. poolChartLoading
                                     */,
  duration: 3500, // Set animation duration(milliseconds) as per your animation
};

/**************               Home Page                    ****************/

//SEO Related settings
const seo = {
  title: "AdityaPartole's Portfolio",
  description: "Portfolio Website of Aditya Partole",
  og: {
    title: "AdityaPartole Portfolio",
    type: "website",
    url: "https://AdityaPartole.github.io/",
  },
};

//Home Page
const greeting = {
  title: "Aditya Partole",
  logo_name: "Aditya Partole",
  nickname: "The Complex",
  subTitle:
  "A code enthusiast and student on the journey of mastering full stack development and Java-based Data Structures and Algorithms—transforming lines of code into magic!",
  resumeLink:
    "https://drive.google.com/file/d/1V-SMcMV9ptDmEcdKFrx7vHjV4MBWAADd/view?usp=sharing",
  portfolio_repository: "https://drive.google.com/file/d/1V-SMcMV9ptDmEcdKFrx7vHjV4MBWAADd/view?usp=sharing", //star-me-on-github button
  githubProfile: "https://github.com/AdityaPartole", //more projects button
};

const socialMediaLinks = [
  /* Your Social Media Links */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/AdityaPartole",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/aditya-partole-a81030241/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  //  {
  //    name: "YouTube",
  //    link: "https://www.youtube.com/channel/UC_amoXmmxSY9KusoDczDTXQ",
  //    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  //  },
  // {
  //   name: "Gmail",
  //   link: "mailto:kasroudrakrd@gmail.com",
  //   fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
  //   backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  // },
  // {
  //   name: "Twitter",
  //   link: "https://twitter.com/AdityaPartole",
  //   fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
  //   backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  // },
  {
    name: "Stackoverflow",
    link: "https://stackoverflow.com/users/23242184/aditya-partole",
    fontAwesomeIcon: "fa-stack-overflow", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
  {
    name: "Twitter",
    link: "https://twitter.com/AdityaPartole",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Telegram",
    link: "https://t.me/AdityaPartole",
    fontAwesomeIcon: "fa-telegram", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Medium",
    link: "https://medium.com/@aditya.partole21",
    fontAwesomeIcon: "fa-medium", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Hashnode",
    link: "https://hashnode.com/@AdityaPartole",
    fontAwesomeIcon: "fa-hashnode", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  // {
  //   name: "Facebook",
  //   link: "https://www.facebook.com/AdityaPartole/",
  //   fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
  //   backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  // },
  //  {
  //    name: "Instagram",
  //    link: "https://www.instagram.com/layman_brother/",
  //    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
  //    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  //  },
];

// Skill Information

const skills = {
  display: true, // Set it true to display your skills
  data: [
    {
      title: "Full Stack Developer",
      imageName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using React-Redux.",
        "⚡ Creating application backend in Node & Express with MongoDB as database.",
        "⚡ Proficient in developing a wide range of websites using diverse technology stacks.",
        // "⚡ Loves to create web application using ReactJS!",
        // "⚡ Creating simple APIs by NodeJS and ExpressJS with MongoDB as database.",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            backgroundColor: "#000000",
            color: "#1572B6",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "ExpressJS",
          fontAwesomeClassname: "simple-icons:express",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Redux",
          fontAwesomeClassname: "simple-icons:redux",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "fa6-brands:node",
          style: {
            color: "#6A9955",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "logos-php",
          style: {
            color: "transparent",
          },
        },
        {
          skillName: "WordPress",
          fontAwesomeClassname: "simple-icons:wordpress",
          style: {
            color: "#0073aa",
          },
        },
          {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
      ],
    },
    // {
    //   title: "Java Developer",
    //   imageName:"AppDevelopImg",
    //      /* Available imageNames:

    //   FullStackImg,
    //   TerminalImg,
    //   DesignImg,
    //   AppDevelopImg,
    //   CloudInfraImg,
    //   DataScienceImg.
    //   */
    //   skills: [
    //     "⚡ Stil beginner in this field.",
    //     "⚡ Currently learning Spring and Hibernate frameworks.",
    //     // "⚡ ",
    //     // "⚡ ",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Java",
    //       fontAwesomeClassname: "logos:java",
    //       style: {
    //         color: "#007396",
    //       },
    //     },
    //     {
    //       skillName: "Java",
    //       fontAwesomeClassname: "logos:spring",
    //       style: {
    //         color: "#007396",
    //       },
    //     },
    //     {
    //       skillName: "Java",
    //       fontAwesomeClassname: "logos:hibernate",
    //       style: {
    //         color: "#007396",
    //       },
    //     },
    //     {
    //       skillName: "Git",
    //       fontAwesomeClassname: "logos-git-icon",
    //       style: {
    //         color: "#F05032",
    //       },
    //     },
    //   ],
    // },
    {
      title: "Data Science & AI",
      imageName:"DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases.",
        "⚡ Experience of working with Computer Vision and NLP projects.",
        // "⚡ ",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            color: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "transparent",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "simple-icons:pytorch",
          style: {
            color: "#E76F51",
          },
        },
        // {
        //   skillName: "Numpy",
        //   fontAwesomeClassname: "simple-icons:numpy",
        //   style: {
        //     color: "#1f77b4",
        //   },
        // },
        // {
        //   skillName: "Pandas",
        //   fontAwesomeClassname: "logos-pandas",
        //   style: {
        //     color: "transparent",
        //   },
        // },
        // {
        //   skillName: "Matplotlib",
        //   fontAwesomeClassname: "logos-matplotlib",
        //   style: {
        //     color: "transparent",
        //   },
        // },
        // {
        //   skillName: "scikit-learn",
        //   fontAwesomeClassname: "",
        //   style: {
        //     color: "#E76F51",
        //   },
        // },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        // {
        //   skillName: "Power-Bi",
        //   fontAwesomeClassname: "logos:Power-Bi",
        //   style: {
        //     color: "transparent",
        //   },
        // },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      imageName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms.",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases.",
        "⚡ Deploying deep learning models on cloud to use on mobile devices.",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "logos-mysql",
          style: {
            color: "transparent",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        // {
        //   skillName: "Docker",
        //   fontAwesomeClassname: "simple-icons:docker",
        //   style: {
        //     color: "#1488C6",
        //   },
        // },
        // {
        //   skillName: "Kubernetes",
        //   fontAwesomeClassname: "simple-icons:kubernetes",
        //   style: {
        //     color: "#326CE5",
        //   },
        // },
      ],
    },
  ],
};

const techStack = {
  // Skill Part
  display: false, // Set it to true to view skillbars of language
  title: "Proficiency",
  experience: [
    {
      Stack: "HTML", // Insert stack or technology or language you have experience in
      progressPercentage: "90%", // Insert relative proficiency in percentage
    },
    {
      Stack: "CSS/SASS",
      progressPercentage: "80%",
    },
    {
      Stack: "JavaScript/TypeScript",
      progressPercentage: "80%",
    },
    {
      Stack: "PHP",
      progressPercentage: "60%",
    },
    {
      Stack: "Python",
      progressPercentage: "80%",
    },
    {
      Stack: "Shell",
      progressPercentage: "80%",
    },
    {
      Stack: "Perl",
      progressPercentage: "70%",
    },
    {
      Stack: "Ruby",
      progressPercentage: "70%",
    },
    {
      Stack: "C",
      progressPercentage: "60%",
    },
    {
      Stack: "Rust",
      progressPercentage: "60%",
    },
    {
      Stack: "Java",
      progressPercentage: "60%",
    },
    {
      Stack: "Lua",
      progressPercentage: "60%",
    },
    {
      Stack: "GO",
      progressPercentage: "60%",
    },
    {
      Stack: "CPP",
      progressPercentage: "50%",
    },
  ],
};

// Top Contributioned projects
const bigProjects = {
  display: false, // Set it true to show big projects
  title: "Big Projects",
  subtitle: "Some startups and companies that i helped to create their tech",
  projects: [
    {
      image: "saayaHealthLogo.png",
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/",
        },
        //  you can add extra buttons here.
      ],
    },
    {
      image: "nextuLogo.jpg",
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/",
        },
      ],
    },
  ],
};

const blogSection = {
  display: false, // Set it none to hide blogs or set it to hardcdoded for following blogs otherwise you can set it to medium to show your fetched(if you used your username for fetcher.mjs) medium blogs
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  blogs: [
    {
      url:
        "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?",
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies.",
    },
  ],
};

const talkSection = {
  display: false, // Set it true to show talks
  title: "Talks",
  subtitle: "I love to share my limited knowledge and get a speaker badge",

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/",
    },
  ],
};

// Podcast Section

const podcastSection = {
  display: false, // Set it true to show your podcasts
  title: "Podcast",
  subtitle: "I love to talk about myself and technology",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo",
  ],
};

// Your tweets displayed in a iframe
const twitterUsername = "none"; // set it none to display no tweets

/****************               Education Page          ****************/

// Your profiles in Competitive Sites to be displayed in education page
const competitiveSites = {
  display: true, // Set it to true to show icons containing links to your profile in respective sites
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/profile/AdityaPartole",
    },
    
    {
      siteName: "Leetcode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#FFD700",
      },
      profileLink: "https://leetcode.com/AdityaPartole/",
    },
    // {
    //   siteName: "Codechef",
    //   iconifyClassname: "simple-icons:codechef",
    //   style: {
    //     color: "#5B4638",
    //   },
    //   profileLink: "https://www.codechef.com/users/adityapartole",
    // },
    // {
    //   siteName: "Hackerearth",
    //   iconifyClassname: "simple-icons:hackerearth",
    //   style: {
    //     color: "#323754",
    //   },
    //   profileLink: "https://www.hackerearth.com/@ashutosh391",
    // },
    // {
    //   siteName: "Kaggle",
    //   iconifyClassname: "simple-icons:kaggle",
    //   style: {
    //     color: "#20BEFF",
    //   },
    //   profileLink: "https://www.kaggle.com/laymanbrother",
    // },
  ],
};

// Degrees received from institutions
const degrees = {
  display: true, // Set it false to hide degrees, defaults to true
  degrees: [
    {
      title: "Vishwakarma Institute of Technology, Pune, Maharashtra, India.",
      subtitle: "B.Tech in Instrumentation & Control Engneering, Current CGPA - 8.52/10",
      logo_path: "vit_logo.png",
      alt_name: "VIT",
      duration: "Dec 2021 - Present",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, DSA, DBMS, OOP, AIML etc. ",
        "⚡ Apart from this, I have done courses on Deep Learning, Data Science, Cloud Computing and Full Stack Development.",
        "⚡ I was selected for a free LinkedIn Learning subscription, which is awarded to the top 10% of students in college."
      ],
      website_link: "https://www.vit.edu/",
    },
    {
      title: "Smt. Chandibai Himathmal Mansukhani College, Ulhasnagar, Maharashtra, India.",
      subtitle: "Class 12 (HSC-Science PCM), Percentage - 89.17/100",
      logo_path: "chm_logo.png",
      alt_name: "CHM",
      duration: "Jun 2020 - Oct 2021",
      descriptions: [
        "⚡ Overcame a significant educational transition from Marathi medium in Class 1 to 10 to English medium in Class 11 and 12.",
        "⚡ Successfully adapted to an English medium environment, showcasing resilience and dedication to academic excellence.",
        "⚡ Successfully completed a rigorous curriculum with a focus on Physics, Chemistry, and Mathematics (PCM), demonstrating proficiency in core Science disciplines."
      ],
      website_link: "https://www.chmcollege.in/",
    },
    {
      title: "Gurunath Damodar Kanthe Gurukul, Vasind, Maharashtra, India.",
      subtitle: "Class 10 (SSC), Percentage - 90.60/100",
      logo_path: "gdk_logo.png",
      alt_name: "GDK",
      duration: "Jun 2018 - Mar 2019",
      descriptions: [
        "⚡ Attained the 5th rank, highlighting excellent academic performance and a competitive edge among classmates.",
        "⚡ Beyond academic achievements, actively engaged in co-curricular activities, contributing to a holistic development approach encouraged by the institution.",
        "⚡ Developed leadership skills and teamwork through participation in various school events and collaborative projects with peers."
      ],
      website_link: "https://drive.google.com/file/d/1Gd-NEC1A3jILWU0_4SFB5gKJ0qI1a1TF/view?usp=sharing",
    },
  ],
};

// Certifications in education page
const certifications = {
  display: true, // Set it false to hide certifications, defaults to true
  certifications: [
    {
      title: "Computer Vision",
      subtitle: "- Abhilash Nelson",
      logo_path: "udemy_logo.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-d10c4971-8ea1-46f5-a276-804b5b527338/",
      alt_name: "Stanford University",
      color_code: "#800080",
    },
    {
      title: "Java + DSA",
      subtitle: "- Shradha Khapra",
      logo_path: "Javadsa_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1Ea9GTkqsDJUvOKu5SjsrxZgZfT8ziM92/view?usp=sharing",
      alt_name: "Stanford University",
      color_code: "#ffffff",
    },
    {
      title: "Software Development Trainee",
      subtitle: "- AMCAT",
      logo_path: "amcat_logo.png",
      certificate_link:
        "https://www.myamcat.com/certificate/29922453/software-development-trainee/166",
      alt_name: "deeplearning.ai",
      color_code: "#FFFFFF",
    },
    {
      title: "Data Processing Specialist",
      subtitle: "- AMCAT",
      logo_path: "amcat_logo.png",
      certificate_link:
        "https://www.myamcat.com/certificate/29922453/data-processing-specialist/211",
      alt_name: "Google",
      color_code: "#FFFFFF",
    },
    // {
    //   title: "Data Science",
    //   subtitle: "- Alex Aklson",
    //   logo_path: "ibm_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5",
    //   alt_name: "IBM",
    //   color_code: "#1F70C199",
    // },
    {
      title: "HTML Essential Training",
      subtitle: "- Jen Simmons",
      logo_path: "linkk.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/c20a01c93051728f024da5719c0c9d5266aed6a04f0ad369e41464c3c0c52d92?u=126888530",
      alt_name: "Linkedln Learning",
      color_code: "#2A73CC",
    },
    {
      title: "CSS Essential Training",
      subtitle: "- Christina Truong",
      logo_path: "linkk.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/4ad1b9b3fcace45ec54ec6bda1f280b8e5755b4ccc584449222f3b7eade42b4f?u=126888530",
      alt_name: "Linkedln Learning",
      // color_code: "#1F70C199",
      color_code: "#2A73CC",
    },
    {
      title: "JavaScript Essential Training",
      subtitle: "- Morten Rand-Hendriksen",
      logo_path: "linkk.png",
      // certificate_link:
      //   "",
      alt_name: "Linkedln Learning",
      // color_code: "#0C9D5899",
      color_code: "#2A73CC",
    },
    {
      title: "MySQL Essential Training",
      subtitle: "- Bill Weinman",
      logo_path: "linkk.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/1e6bd8319b83951cd7c56f964bf1cbf299aa56006bd803ef9a0b1527833a595a?u=126888530",
      alt_name: "Linkedln Learning",
      // color_code: "#00000099",
      color_code: "#2A73CC",
    },
    {
      title: "Fullstack Development",
      subtitle: "- Love Babbar",
      logo_path: "fullstack_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1RzjXWRNOe0uaocgp9E6LKT_iFiCMTTzt/view?usp=drive_link",
      alt_name: "Coursera",
      color_code: "#4285F499",
    },
    {
      title: "Learning Git and GitHub",
      subtitle: "- Ray Villalobos",
      logo_path: "linkk.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/ad50764bce3ad348ad853f2ffaa957bc6747a62f98196f01cc36df34d84816a5?u=126888530",
      alt_name: "Linkedln Learning",
      // color_code: "#4285F499",#2A73CC
        color_code: "#2A73CC"

    },
    {
      title: "Business Analyst",
      subtitle: "- AMCAT",
      logo_path: "amcat_logo.png",
      certificate_link:
        "https://www.myamcat.com/certificate/29922453/business-analyst/94",
      alt_name: "AMCAT",
      // color_code: "#FFBB0099",
      color_code: "#FFFFFF",

      
    },
    {
      title: "Java Object-Oriented Programming",
      subtitle: "- Kathryn Hodge",
      logo_path: "linkk.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/182e22df4132f6b35fd01631041ca7277363a54c29cb8900d3d9b8a968f67b0c?u=126888530",
      alt_name: "Linkedln Learning",
      // color_code: "#4285F499",
      color_code: "#2A73CC",
    },
    // {
    //   title: "Java Object-Oriented Programming",
    //   subtitle: "- Kathryn Hodge",
    //   logo_path: "linkk.png",
    //   certificate_link:
    //     "https://www.linkedin.com/learning/certificates/182e22df4132f6b35fd01631041ca7277363a54c29cb8900d3d9b8a968f67b0c?u=126888530",
    //   alt_name: "Linkedln Learning",
    //   // color_code: "#4285F499",
    //   color_code: "#2A73CC",
    // },
  ],
};

/*******************          Experience Page          ****************/

const experience = {
  title: "Experience",
  subtitle: "Internship and Leadership Roles",
  description:
  "I'm still in the midst of my educational journey, but I've participated in virtual internship programs. Although these opportunities don't offer a stipend, they involve working on multiple small projects and include valuable interview preparation support.",
  header_image_path: "experience.svg",
  sections: [
    // {
    //   title: "Work",
    //   experiences: [
    //     {
    //       title: "Associate AI Engineer",
    //       company: "Legato Health Technology",
    //       company_url: "https://legatohealthtech.com/",
    //       logo_path: "legato_logo.png",
    //       duration: "June 2020 - PRESENT",
    //       location: "Hyderabad, Telangana",
    //       description:
    //         "I am working on automating healthcare products. The projects involve automation for process improvements and for significantly enhancing the profits. I am currently working on Cancer Survival and Reoccurence Prediction. Our goal is to make AI system which scales and removes doctor dependency as much as possible.",
    //       color: "#0879bf",
    //     },
    //     {
    //       title: "Android and ML Developer",
    //       company: "Muffito Incorporation",
    //       company_url: "https://www.linkedin.com/company/muffito-inc/about/",
    //       logo_path: "muffito_logo.png",
    //       duration: "May 2018 - Oct 2018",
    //       location: "Pune, Maharashtra",
    //       description:
    //         "I have created complete Android Application for locating Pub, Bar and beverage shops around you. I have also worked on implementation of algorithms for Face Detection, Text extraction from Image. I was involved in a team for creating complete software architecure of mobile and web application as well as admin panel for company.",
    //       color: "#9b1578",
    //     },
    //     {
    //       title: "Android Developer",
    //       company: "FreeCopy Pvt. Ltd.",
    //       company_url: "https://www.linkedin.com/company/freecopy/about/",
    //       logo_path: "freecopy_logo.png",
    //       duration: "Nov 2017 - Dec 2017",
    //       location: "Ahmedabad, Gujarat",
    //       description:
    //         "FreeCopy is the Start up from Indian Institute of Management, Ahmedabad. I have changed the integration of the whole app from Google to Firebase. I learnt the efﬁcient ways of Data communications like Retroﬁt, Eventbus etc. I experienced the real time start up. I learnt the Design thinking of UI on perspective of People.",
    //       color: "#fc1f20",
    //     },
    //   ],
    // },
    {
      title: "Internships",
      experiences: [
        {
          title: "Java Developer",
          company: "Oasis Infobyte",
          company_url: "https://oasisinfobyte.com/",
          logo_path: "oasis_infobyte_logo.png",
          duration: "Jan 2024 - Present",
          location: "Virtual",
          description:
            "As a current Java Developer intern at Oasis Infobyte, I've contributed to diverse projects, including an Online Reservation System, Number Guessing Game, and an ATM Interface. Future tasks involve an Online Examination system and a Digital Library Management project, further enhancing my Java development skills.",
          color: "#0071C5",
        },
        {
          title: "Full Stack Developer",
          company: "Bharat Intern",
          company_url:
            "https://bharatintern.live/b/i/index.html",
          logo_path: "bharatintern.jpeg",
          duration: "Sep 2023 - Oct 2023",
          location: "Virtual",
          description:
            "During my internship at Bharat Intern, I undertook diverse projects showcasing my Full Stack Development skills. I designed an intuitive Content Management Tool with drag-and-drop interfaces for creating blogs. Additionally, I contributed to a Project Management Tool, integrating social media elements for user interaction and task assignment capabilities. Another significant project involved enhancing a Video Conferencing Website, where I implemented features like textual chatting, audio-video interactions, and video recording. These experiences honed my abilities in creating dynamic web applications and collaborating within a team environment.",
          color: "#0071C5",
        },
        {
          title: "Data Analyst",
          company: "YBI Foundation",
          company_url:
            "https://www.ybifoundation.org/",
          logo_path: "ybi_logo.png",
          duration: "Jul 2023 - Sep 2023",
          location: "Virtual",
          description:
            "As a Data Analyst at YBI Foundation, I was actively engaged in a three-month internship program focused on Data Analytics. This opportunity allowed me to learn the fundamental concepts of Data Analytics from scratch, providing a comprehensive understanding of the field.",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Leadership Roles",
      experiences: [
        {
          title: "MyGov Campus Ambassador",
          company: "MyGov India",
          company_url: "https://www.mygov.in/",
          logo_path: "gov_logo.jpeg",
          duration: "Sep 2023 - Present",
          location: "On Campus",
          description:
            "As a proud MyGov Campus Ambassador at VIT Pune, I am honored to represent the essence of the MyGov initiative on our campus. My role involves disseminating information about MyGov activities, campaigns, and contests, fostering engagement among students, and organizing impactful events to promote MyGov programs.",
          color: "#0071C5",
        },
        {
          title: "Scholarship Coordinator",
          company: "Social Welfare & Development Committee",
          company_url: "https://swd.vit.edu/",
          logo_path: "swd_logo.png",
          duration: "Aug 2023 - Present",
          location: "On Campus",
          description:
            "As the Scholarship Coordinator at VIT Pune's Social Welfare & Development Committee, I play a pivotal role in championing educational opportunities and financial support for deserving students. My responsibilities include overseeing scholarship programs, facilitating student applications, and collaborating with external partners to enhance scholarship offerings.",
          color: "#0071C5",
        },
        {
          title: "IEEE SB VIT Pune-Member",
          company: "IEEE",
          company_url: "https://www.ieeevitpune.com/",
          logo_path: "ieeesb_logo.jpeg",
          duration: "Feb 2023 - Present",
          location: "On Campus",
          description:
            "As a member of IEEE SB VIT Pune, I actively contribute to fostering technological innovation and excellence. Engaging in various activities, the IEEE Student Branch at VIT Pune aims to enhance skills and readiness for competitive programming, preparing students for renowned competitions like ACM. The club serves as a platform to propagate scientific expertise, providing opportunities for hands-on learning, networking, and personal growth. Additionally, our commitment extends to community involvement, as seen in our collaborative efforts with local organizations and initiatives.",
          color: "#0071C5",
        },
        // {
        //   title: "Developer Students Club Member",
        //   company: "DSC IIITDM Kurnool",
        //   company_url:
        //     "https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
        //   logo_path: "dsc_logo.png",
        //   duration: "Jan 2018 - May 2020",
        //   location: "Kurnool, Andhra Pradesh",
        //   description:
        //     "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
        //   color: "#0C9D58",
        // },
        // {
        //   title: "Developer Program Member",
        //   company: "Github",
        //   company_url: "https://github.com/",
        //   logo_path: "github_logo.png",
        //   duration: "July 2019 - PRESENT",
        //   location: "Work From Home",
        //   description:
        //     "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
        //   color: "#181717",
        // },
      ],
    },
  ],
};

/********************              Hobbies         ********************/

const hobbies = {
  title: "Hobbies",
  subTitle: "I spend my leisure with my hobbies!",
  hobbies: [
    {
      title: "Reading Books",
      description: "I love to read sci-fi and detective books!",
      image_path: "Reading.png",
    },
    {
      title: "Writing",
      description: "I write blogs when I get free times!",
      image_path: "Writing.png",
    },
    // {
    //   title: "Memeing",
    //   description:
    //     "I have a collection of meme templates and I use them to generate memes!",
    //   image_path: "Memeing.png",
    // },
    {
      title: "Listening Music",
      description: "I am a fan of Alan Walker and Linkin Park!",
      image_path: "Music.png",
    },
  ],
};

/****************            OpenSource Page           ********************/

const openSource = {
  organisations: true, // Set it false to hide contributions in github organisations, defaults to true

  issues: true, // Set it false to hide your opened isssues, defaults to true

  pull_requests: true, // Set it false to hide your pull requests in github organisations, defaults to true

  issue_chart: true, // Set it false to hide issue chart, defaults to true

  pr_chart: true, // Set it false to hide pull requests chart, defaults to true
};

/****************            Projects Page           ********************/

// Projects (Github) Section of Projects Page
const projects = {
  display: true, // Set it false to hide your pinned projects in github, defaults to true
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. Engage with live demonstrations of hosted websites, showcasing the tangible outcomes of my coding expertise.",
  avatar_image_path: "projects_image.svg",
};

// Publication Section of Projects Page
const publications = {
  display: true, // Set it true to show publications
  title: "Publication & Patent",
  description:
    "",
  avatar_image_path: "projects_image.svg",
  publications: {
    data: [
      {
        id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
        name: "Suggesting the best courses using sentiment analysis.",
        createdAt: "--",
        description:
        "Yet to be published.",
        url: "",
      },
      // {
      //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=",
      //   name: "IEEE Paper",
      //   createdAt: "2024",
      //   description:
      //     "TY sem -2 EDI Paper ",
      //   url: "https://example.com",
      // },
      {
        id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNze=",
        name: "Smart Motorcycle Helmet",
        createdAt: "--",
        description:
          "Indian Patent in process.",
        url: "",
      },
      // {
      //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzt=",
      //   name: "Artificial Intelligence Paper",
      //   createdAt: "2020-03-06T16:26:54Z",
      //   description:
      //     "Paper Written on Artificial Intelligence published in xyz ",
      //   url: "https://example.com",
      // },
      // {
      //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzb=",
      //   name: "Artificial Intelligence Paper",
      //   createdAt: "2020-03-06T16:26:54Z",
      //   description:
      //     "Paper Written on Artificial Intelligence published in xyz ",
      //   url: "https://example.com",
      // },
    ],
  },
};


/*******************          Contact Page          ****************/

const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "my_logoo.png",
    description:
      "You can message me (except hi/hello), I will reply within 24 hours. Ask me anything, and I am happy to help, (only if the ball is in my court!😉)",
  },
  blogSection: {
    title: "Blogs",
    subtitle: "I write blogs when I have free time!",
    link: "https://adityapartole.hashnode.dev/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Vasind, Tal. - Shahapur, Dist. - Thane, Maharashtra, India.",
    avatar_image_path: "address_image.svg",
    location_map_link:
      "https://www.google.com/maps/place/Vasind,+Maharashtra+421601/@19.4051436,73.2631017,15z/data=!3m1!4b1!4m6!3m5!1s0x3be79b25bbd8c703:0x4e6abfbdf415ae89!8m2!3d19.4060313!4d73.2664717!16s%2Fm%2F02rcdg5?entry=ttu",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 9561493042",
  },
};

// Send a message in emailjs account
const contactMessage = {
  display: true, // Set it false if you don't have emailjs account or you don't want message, defaults to true
  emailjsUserID: "ygIID1u6MHnuKXwBt",
  templateID: "template_2p5dt2c",
  serviceID: "service_6vxppsc",
};

export {
  pageEnabled,
  routerValue,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  techStack,
  competitiveSites,
  degrees,
  certifications,
  experience,
  hobbies,
  podcastSection,
  bigProjects,
  talkSection,
  openSource,
  projects,
  publications,
  blogSection,
  contactPageData,
  contactMessage,
  twitterUsername,
  splashScreen,
};
